// Access policy and password verification belong to the API, never to build-time env.
const API = process.env.NODE_ENV === 'development'
  ? '' : (process.env.VUE_APP_LENDIQ_API_URL || 'https://api.lendiq.app').replace(/\/$/, '')
const STORAGE_KEY = `corporate-stage-session:${API}`
let session
try { session = JSON.parse(sessionStorage.getItem(STORAGE_KEY)) } catch { /* Storage may be unavailable. */ }
function token() {
  return session && Date.parse(session.expires_at) > Date.now() ? session.session_token : null
}
function saveSession(value) {
  session = value
  try {
    if (value) sessionStorage.setItem(STORAGE_KEY, JSON.stringify(value))
    else sessionStorage.removeItem(STORAGE_KEY)
  } catch { /* Keep the session in memory if browser storage is disabled. */ }
}
export function stageHeaders() {
  const value = token()
  return value ? { Authorization: `Bearer ${value}` } : {}
}
export function checkStageResponse(response) {
  if (response.status === 401) {
    saveSession(null)
    window.dispatchEvent(new Event('stage-locked'))
  }
  return response
}
export function stageAssetUrl(value) {
  if (!value || !token()) return value
  const base = API || window.location.origin
  const url = new URL(value, base)
  // Never send the session to an external image, CDN or document provider.
  if (url.origin !== new URL(base).origin || !/^\/api\/v1\/corporate-site\/(?:news\/[^/]+\/image|notices\/[^/]+\/image|documents\/[^/]+\/download)$/.test(url.pathname)) return value
  url.searchParams.set('session_token', token())
  return url.href
}
export async function checkStageAccess() {
  const response = await fetch(`${API}/api/v1/corporate-site/access`, { headers: stageHeaders(), credentials: 'omit', cache: 'no-store' })
  if (!response.ok) throw new Error('Не вдалося перевірити доступ. Спробуйте ще раз.')
  const status = await response.json()
  if (typeof status.is_prod !== 'boolean' || typeof status.authorized !== 'boolean') throw new Error('Некоректна відповідь перевірки доступу.')
  if (status.is_prod) saveSession(null)
  else {
    let meta = document.querySelector('meta[name="robots"]')
    if (!meta) { meta = document.createElement('meta'); meta.name = 'robots'; document.head.appendChild(meta) }
    meta.content = 'noindex'
  }
  return status
}
export async function verifyStageKey(password) {
  if (/^[a-f0-9]{64}$/.test(password)) {
    const response = await fetch(`${API}/api/v1/corporate-site/access`, { headers: { Authorization: `Bearer ${password}` }, credentials: 'omit', cache: 'no-store' })
    if (response.ok && (await response.json()).authorized === true) {
      saveSession({ session_token: password, expires_at: new Date(Date.now() + 8 * 3600000).toISOString() })
      return true
    }
  }
  const response = await fetch(`${API}/api/v1/corporate-site/access/unlock`, {
    method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'omit', cache: 'no-store', body: JSON.stringify({ password }),
  })
  if (response.status === 401) return false
  if (response.status === 429) throw new Error('Забагато спроб. Спробуйте пізніше.')
  if (!response.ok) throw new Error('Не вдалося відкрити сайт. Спробуйте ще раз.')
  const value = await response.json()
  if (typeof value.session_token !== 'string' || !/^[a-f0-9]{64}$/.test(value.session_token) || !(Date.parse(value.expires_at) > Date.now())) throw new Error('Некоректна сесія доступу.')
  saveSession(value)
  return true
}
